"use strict";
'use es6';
/**
 * Instead of implementing this utility directly, use either the ./pick or ./omit utilities which implement this one.
 * Those utilities are designed to mimic the functionality of _.pick and _.omit.
 * @param {Object} object - object to run filters on
 * @param {Boolean} include - true if the filters should include properties of the object on the returned value.
 *                            false if it should exclude them from the returned value.
 * @param {String|String[]} filters - property name or names to include/exclude
 */

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends4 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var objectFilter = function objectFilter(object, include) {
  if (object == null) return object;

  for (var _len = arguments.length, filters = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    filters[_key - 2] = arguments[_key];
  }

  var filtersAsArray = filters.reduce(function (filterAccum, filter) {
    if (typeof filter === 'string') {
      return [].concat((0, _toConsumableArray2.default)(filterAccum), [filter]);
    }

    return [].concat((0, _toConsumableArray2.default)(filterAccum), (0, _toConsumableArray2.default)(filter));
  }, []);
  return Object.keys(object).reduce(function (prev, key) {
    var passesFilter = include ? (0, _extends4.default)({}, prev, (0, _defineProperty2.default)({}, key, object[key])) : prev;
    var failsFilter = include ? prev : (0, _extends4.default)({}, prev, (0, _defineProperty2.default)({}, key, object[key]));
    return filtersAsArray.includes(key) ? passesFilter : failsFilter;
  }, {});
};

var _default = objectFilter;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/utils/underscore/objectFilter.js
// module id = 358
// module chunks = 209 210 211 212